export default __webpack_public_path__ + "static/productionbookicon-6ec69085fd6a1f313b2f35023a1b875b.png";